import { Menu, Transition } from "@headlessui/react";
import { CiEdit } from "react-icons/ci";
import { FiFileMinus } from "react-icons/fi";
import { IoMdMore } from "react-icons/io";
import { MdDelete } from "react-icons/md";
import { Fragment } from "react/jsx-runtime";
import ContracctDetails from "../../../pages/modules/employee/ContracctDetails";
import useAppraisalTempHook from "../../../hooks/useAppraisalTempHook";
import { useEffect, useState } from "react";
import { useStateSetter } from "../../../hooks/statehooks/UseStateSettersHook";
import PreviewAppraisalTemplateModal from "./PreviewAppraisalTemplateModal";
import EditAppTemplateModal from "./EditAppTemplateModal";
import BuildAppraisalTemplateModal from "./BuildAppraisalTemplateModal";
import { AiOutlineFileText } from "react-icons/ai";

export default ({ item, refresh }: any) => {
  const { getTempQuestions } = useAppraisalTempHook();
  const [quest, setquest] = useState([]);

  const { showModal, setShowModal } = useStateSetter();
  const [showedit, setshowedit] = useState(false);
  const [showbuilder, setshowbuilder] = useState(false);

  const init = async () => {
    try {
      var quest_ = await getTempQuestions(item.id);
      setquest(quest_);
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    init();
  }, [item.id]);

  return (
    <div className="p-1 border-2 border-gray-100 rounded-[10px]  my-2  flex items-center justify-between">
      {showedit && (
        <EditAppTemplateModal
          refresh={refresh}
          item={item}
          show={setshowedit}
        />
      )}
      {showbuilder && (
        <BuildAppraisalTemplateModal
          refresh={refresh}
          item={item}
          show={setshowbuilder}
        />
      )}
      <p className="text-xs ">
        <AiOutlineFileText className="inline" /> {item.name}
      </p>
      <Menu as="div" className={`relative my-2 `}>
        <Menu.Button className="   w-full       ">
          <div className="flex flex-items items-center  w-full gap-4">
            <div className=" flex justify-between w-full  items-center p-1">
              <IoMdMore size={20} className="text-textbg " />
            </div>

            <div className="flex items-center"></div>
          </div>
        </Menu.Button>

        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items
            onClick={() => {}}
            className="origin-top-left z-10 absolute left-0 mt-2 rounded-sm shadow-md p-1 bg-white w-full  max-h-[200px] min-w-[180px]   overflow-x-hidden overflow-y-scroll ring-1 ring-black ring-opacity-5 focus:outline-none"
          >
            <Menu.Item>
              <p
                onClick={() => {
                  setshowbuilder(true);
                }}
                className=" text-xs font-light w-full text-black p-3 m-2 cursor-pointer truncate hover:bg-customGray "
              >
                <CiEdit className="inline" /> Edit 
              </p>
            </Menu.Item>

            <Menu.Item>
              <p
                onClick={async () => {
                  showModal(
                    "",
                    "",
                    "",
                    <PreviewAppraisalTemplateModal
                      show={setShowModal}
                      item={item}
                    />
                  );
                }}
                className=" text-xs font-light w-full text-black p-3 m-2 cursor-pointer truncate hover:bg-customGray "
              >
                <FiFileMinus className="inline" /> View
              </p>
            </Menu.Item>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
};
